export default function WhyUsSection() {
  const features = [
    {
      icon: 'ri-timer-flash-line',
      title: 'Lightning Fast Delivery',
      desc: 'Average 28-minute delivery across Georgetown. From Kitty to Campbellville, we\'ve got every neighborhood covered.',
      image: 'https://public.readdy.ai/ai/img_res/57e162903ac0bdeb4eaab138a5ef4887.jpg',
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Secure Online Payment',
      desc: 'Multiple payment methods with bank-grade encryption. Pay with card, mobile money, or cash on delivery.',
      image: 'https://readdy.ai/api/search-image?query=secure%20mobile%20payment%20phone%20contactless%20digital%20wallet%20clean%20minimal%20white%20background%20technology%20finance%20modern&width=500&height=300&seq=why2&orientation=landscape',
    },
    {
      icon: 'ri-star-line',
      title: 'Verified Store Reviews',
      desc: 'Every review is from a verified customer. Browse honest ratings to pick the best partner store for your order.',
      image: 'https://readdy.ai/api/search-image?query=customer%20reviews%20rating%20stars%20satisfaction%20happy%20customers%20digital%20phone%20app%20five%20stars%20tropical%20Caribbean%20colorful&width=500&height=300&seq=why3&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <span className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-bold px-3 py-1 rounded-full mb-4 tracking-widest uppercase">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em' }}>
              Why Choose <span className="text-[#FF6B35]">/</span><br />
              Our Service
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs leading-relaxed">
            Built specifically for Georgetown's fast-paced lifestyle. Here's what sets SipDash apart from the rest.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {features.map((feat, i) => (
            <div
              key={feat.title}
              className="bg-[#F5F5F3] rounded-2xl overflow-hidden group hover:scale-[1.02] transition-transform duration-300"
            >
              {/* Image */}
              <div className="h-44 overflow-hidden">
                <img
                  src={feat.image}
                  alt={feat.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 text-[#FF6B35] rounded-xl mb-4">
                  <i className={`${feat.icon} text-xl`} />
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-2">{feat.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Category explorer */}
        <div className="mt-16 bg-[#0D0D0D] rounded-3xl p-10 flex flex-col md:flex-row items-center gap-10">
          <div className="flex-1">
            <span className="inline-block bg-[#FF6B35]/20 text-[#FF6B35] text-xs font-bold px-3 py-1 rounded-full mb-4 tracking-widest uppercase">
              Browse by Category
            </span>
            <h3 className="text-white font-black text-3xl mb-3" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em' }}>
              Over 200+ Beverage<br />Options Available
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">
              From local Banks Beer and El Dorado Rum to imported wines, energy drinks, and refreshing soft drinks — we have everything.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-3">
            {[
              { emoji: '🍺', label: 'Beer', count: '45+' },
              { emoji: '🍷', label: 'Wine', count: '30+' },
              { emoji: '🥃', label: 'Spirits', count: '50+' },
              { emoji: '🥤', label: 'Soft Drinks', count: '40+' },
              { emoji: '⚡', label: 'Energy', count: '20+' },
              { emoji: '💧', label: 'Water', count: '15+' },
            ].map((cat) => (
              <div
                key={cat.label}
                className="bg-white/10 hover:bg-white/20 transition-colors rounded-xl p-4 text-center cursor-pointer"
              >
                <span className="text-2xl block mb-1">{cat.emoji}</span>
                <p className="text-white text-xs font-semibold">{cat.label}</p>
                <p className="text-white/40 text-xs">{cat.count}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
